import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#048138',
    },
    secondary :{
      main: '#323232', //E5E6F0
    }
  },
});

export default theme;